<template>
  <div class="location">
    <el-button type="text"
               :disabled="(disabled && status=='edit') ? true:false"
               class="iconfont-lunan icon-lunan-dingwei"
               @click="openMap"> {{status!='edit'?'查看当前位置':"获取当前位置"}}</el-button>
    {{chooseMap?'【'+chooseMap+'】':''}}
    <!-- 引入gis地图 -->
    <el-dialog :title="dialogTitle"
               v-dialogDrag
               :visible.sync="showMap"
               @close="mapClose"
               @click="mapCancleOpt">
      <div id="mini-map"></div>
      <!-- 底部操作按钮 -->
      <span slot="footer"
            v-if="status=='edit'"
            class="dialog-footer">
        <el-button type="primary"
                   @click="mapConfirmOpt">{{$t('workOrder.button.confirm')}}</el-button>
        <el-button @click="mapCancleOpt">{{$t('workOrder.button.cancel')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'location',
  model: {
    prop: 'chooseMap',
    event: 'handleReturn'
  },
  props: {
    status: {
      type: String,
      default: () => {
        return 'edit'
      }
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    chooseMap: {
      // type: Array,
      // default: () => {
      //   return []
      // }
      type: String,
      default: () => {
        return ''
      }
    }
  },
  watch: {
    chooseMap (newVal) {
      this.location = newVal;
    },
    location (newVal) {
      this.location = newVal;
      this.$emit('handleReturn', this.location);
    }
  },
  data () {
    return {
      dialogTitle: "选择位置",
      location: [],
      showMap: false
    }
  },
  computed: {
  },
  mounted () {
    console.log(this.status)
  },
  methods: {
    mapConfirmOpt () {
      console.log(this.point)
      if (this.point) {
        this.location = []
        this.location.push(Number(this.point[0]).toFixed(10), Number(this.point[1]).toFixed(10))
        this.location = this.location.join(',')
      }

      this.showMap = false;
    },
    mapCancleOpt () {
      this.showMap = false;
      this.$map.hideMap2D()
    },
    mapClose () {
      this.$map.hideMap2D()
    },
    openMap () {
      this.showMap = true;
      this.$nextTick(() => {
        this.$map.showMap2D(this.initMap);
      })
    },
    initMap () {
      if (this.chooseMap) {
        // 回显
        this.getLocationCB(this.chooseMap.split(","))
      } else {
        // this.$map.MapInstance2D.setMapOption();
        this.$map.MapInstance2D.setMapCenter();
      }
      this.$map.MapInstance2D.resetMapStyle('mini-map');
      if (this.status != 'edit') {
        this.dialogTitle = '地图选中位置'
        return
      }
      this.$map.MapInstance2D.getLocation(this.getLocationCB);

    },
    getLocationCB (event) {
      this.point = event;
      let option = [{
        id: 'point_' + new Date().getTime(),
        coord: this.point,
        src: 'images/theme/newDark/map/resource/position_red.png'
      }]
      this.$map.MapInstance2D.clearPoint()
      this.$map.MapInstance2D.addMarket(option)
    },
  }
}
</script>

<style>
.location #mini-map {
  height: 450px;
}
</style>